export const numberFormat = (num, decimal = 2) => {
    const formatter = new Intl.NumberFormat('en', {
        minimumFractionDigits: decimal,
    });

    if(decimal === 3){
        let num2decimal = Math.round((num + Number.EPSILON) * 1000) / 1000
        return formatter.format(num2decimal);
    }else{
        let num2decimal = Math.round((num + Number.EPSILON) * 100) / 100
        return formatter.format(num2decimal);
    }
}